import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const useSessionTimer = () => {
  const context = useSelector(({ context }) => context);
  const slMainForceLogoutTimeoutMins = useSelector(
    ({
      main: {
        data: { logout_timeout_mins },
      },
    }) => logout_timeout_mins
  );

  const [remainingSeconds, setRemainingSeconds] = useState(null);

  let slMainForceLogout = null;
  if (
    context?.configVars?.SL_MAIN_FORCE_LOGOUT != null &&
    slMainForceLogoutTimeoutMins != null
  ) {
    slMainForceLogout =
      context?.configVars?.SL_MAIN_FORCE_LOGOUT > slMainForceLogoutTimeoutMins
        ? context?.configVars?.SL_MAIN_FORCE_LOGOUT
        : slMainForceLogoutTimeoutMins;
  } else if (context?.configVars?.SL_MAIN_FORCE_LOGOUT != null) {
    slMainForceLogout = context?.configVars?.SL_MAIN_FORCE_LOGOUT;
  } else if (slMainForceLogoutTimeoutMins != null) {
    slMainForceLogout = slMainForceLogoutTimeoutMins;
  }

  useEffect(() => {
    if (!slMainForceLogout || slMainForceLogout <= 0) {
      setRemainingSeconds(null);
      return;
    }

    const sessionDurationSeconds = slMainForceLogout * 60;

    const calculateRemaining = () => {
      const lastActivity = localStorage.getItem('lastActivity');
      if (!lastActivity) return sessionDurationSeconds;
      const elapsedSeconds = (Date.now() - parseInt(lastActivity)) / 1000;
      return Math.max(0, Math.floor(sessionDurationSeconds - elapsedSeconds));
    };

    setRemainingSeconds(calculateRemaining());

    const interval = setInterval(() => {
      setRemainingSeconds(calculateRemaining());
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [slMainForceLogout]);

  const formatTime = (totalSeconds) => {
    if (totalSeconds === null) return null;
    const h = Math.floor(totalSeconds / 3600);
    const m = Math.floor((totalSeconds % 3600) / 60);
    const s = totalSeconds % 60;
    if (h > 0) {
      return [h, m, s].map((v) => String(v).padStart(2, '0')).join(':');
    }
    return [m, s].map((v) => String(v).padStart(2, '0')).join(':');
  };

  return { remainingSeconds, formattedTime: formatTime(remainingSeconds) };
};

export default useSessionTimer;
